import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {gsap} from "gsap";
import {Loner} from "../../Loner";

/**
 * Created by Jerker Nord on 2022-12-12.
 */

export class LonerShootShootDuckBetTrigger implements FlowStatePresentation {

    private _presentations:SimplePresentation[];
    private _flowStateController:FlowStateController;

    constructor() {
        this._presentations = [

        ]
    }

    public start(flowStateController:FlowStateController) {
        this._flowStateController = flowStateController;

        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?:Function) => flowStateController.setSkipCallback(callback));
    }

    public complete():void {
        /*
        const randomDelay:number = MathHelper.randomNumberInRange(0.5, 1, 2);
        const completeTL:gsap.core.Timeline = gsap.timeline();
        completeTL.add(()=>{Loner.ssdMainView.betSentTime(performance.now())});
        completeTL.add(gsap.timeline({delay:randomDelay}));
        completeTL.add(()=>{this._flowStateController.finish()});

         */
        Loner.ssdMainView.betSentTime(performance.now());
        this._flowStateController.finish();
    }
}